import { API, Auth, graphqlOperation } from 'aws-amplify';
import { createWordpress } from 'graphql/mutations';
import { listWordpresses } from 'graphql/queries';
import { createUser } from 'wordpress';
import _ from 'lodash';

const saveWordpress = async (id) => {
  console.log(id, 'id');
  let res = null;
  if (!id) return false;
  try {
    const { attributes } = await Auth.currentAuthenticatedUser();
    console.log(attributes.sub, 'attributes.sub');
    const wordpressDetails = {
      userId: attributes.sub,
      wordpressUserId: id,
    };
    res = await API.graphql({ query: createWordpress, variables: { input: wordpressDetails } });
  } catch (e) {
    console.error(e.toString());
  }
  return res;
};

const fetchWordpress = async () => {
  let data = [];
  try {
    const { attributes } = await Auth.currentAuthenticatedUser();
    const apiData = await API.graphql(graphqlOperation(listWordpresses, {
      filter: {
        userId: {
          eq: attributes.sub
        }
      }
    }));
    data = apiData;
  } catch (e) {
    console.error(e.toString());
  }
  return data;
};

function findUserById(userId, request) {
  let user = false;
  if (request?.data?.listWordpresses?.items && !_.isEmpty(request?.data?.listWordpresses?.items)) {
    const req = request?.data?.listWordpresses?.items.find(item => item.userId === userId);
    console.log(req, 'req');
    user = req.userId ?? false;
  }
  return user;
}

// TODO vider la table wordpress dynamodb car supprimer profile dans wordpress
export const getUserId = async () => {
  const user = await fetchWordpress();
  const { attributes } = await Auth.currentAuthenticatedUser();
  const wpUser = findUserById(attributes.sub, user);
  if (!wpUser) {
    const wpuser = await createUser(attributes.email, attributes.email, 'secret#64');
    console.log(wpuser.id, 'wpuser');
    if (wpuser.id) {
      const m = await saveWordpress(wpuser.id);
      console.table(m, 'm');
    }
    return wpuser.id;
  }
  return wpUser;
};

export {
  saveWordpress,
  fetchWordpress
};
